__turbopack_context__.v({
  "container": "Menu-module__9dg8zq__container",
  "fadeInItems": "Menu-module__9dg8zq__fadeInItems",
  "link": "Menu-module__9dg8zq__link",
  "linkBtn": "Menu-module__9dg8zq__linkBtn",
  "linkSec": "Menu-module__9dg8zq__linkSec",
  "links": "Menu-module__9dg8zq__links",
  "linksSec": "Menu-module__9dg8zq__linksSec",
  "spacing--lg": "Menu-module__9dg8zq__spacing--lg",
  "spacing--md": "Menu-module__9dg8zq__spacing--md",
  "spacing--sm": "Menu-module__9dg8zq__spacing--sm",
  "spacing--xl": "Menu-module__9dg8zq__spacing--xl",
  "spacing--xs": "Menu-module__9dg8zq__spacing--xs",
  "spacing--xxl": "Menu-module__9dg8zq__spacing--xxl",
  "spacing--xxs": "Menu-module__9dg8zq__spacing--xxs",
  "spacing--xxxl": "Menu-module__9dg8zq__spacing--xxxl",
  "spacing--xxxs": "Menu-module__9dg8zq__spacing--xxxs",
});
